import React from 'react';

import useTheme from '@hero/branding/theme';
import { IconComponentProps } from '@hero/ui-kit/types';

const CommentIcon: React.FC<IconComponentProps> = ({
    type = 'utility',
    size = 'regular',
    disabled = false,
    styles,
    color = 'currentColor',
    ...rest
}) => {
    const { sizing } = useTheme();
    const sizePx = sizing.widths.icon[size];

    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            width={sizePx}
            height={sizePx}
            style={styles}
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            {...rest}
        >
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
    );
};

export default CommentIcon;
